export default __webpack_public_path__ + "static/media/logo.bbb35d09.png";